module.exports = __webpack_public_path__ + "static/media/11.6918d425.JPG";